import React, { useCallback, memo } from 'react';
import { path } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { useGameConfigurationSelector } from 'js/store/hooks';
import { useGameImageUrls } from 'js/hooks/games';
import { Image } from 'js/components/common/Image';
import { useLaunchGame } from 'js/hooks/gameLauncher';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';

import style from './Game.scss';

// Duplicate of GoldenChipsBalances components.
// Since we need to use it for all accordion tables - these components moved here.

export const Game = memo((props: { code: string, className: string, setGameRef?: (ref: HTMLDivElement) => void }) => {
    const { code, className = '', setGameRef } = props;
    const launchGame = useLaunchGame();
    const translate = useTranslations();
    const game = useGameConfigurationSelector(path(['games', code])) as Record<string, string>;
    const imageUrls = useGameImageUrls({ code });

    const onClick = useCallback(() => launchGame({ code, mode: 1 }), [code, launchGame]);

    if (!game) {
        return null;
    }

    const { name } = game;

    return (
        <AccessibilityElement
            title={name}
            onClick={onClick}
            data-game-code={code}
            elementRef={setGameRef}
            className={`${style.container} ${className}`}
            aria-label={`${translate('playtech.mobile.system.game.aria-label')} ${name}`}
        >
            <div className={style.imageContainer} >
                <Image
                    alt={name}
                    src={imageUrls}
                    className={style.image}
                />
            </div>
            <div className={style.titleWrapper}>
                <span className={style.name}>{name}</span>
            </div>
        </AccessibilityElement>
    );
});
